export default __webpack_public_path__ + "static/media/upload-gdrive.5460f6ba.svg";